import styled from 'styled-components';

export const SmsTermsLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;
